import { Injectable } from '@angular/core';
import { FeathersService } from '../feathers.service';
import { Observable, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export interface MyPermission {
  allocationId: number;
  permissions: {
    id: number;
    name: string;
    description: string;
    createdAt: string; // ISO date string format
    updatedAt: string; // ISO date string format
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class MyPermissionService {
  private readonly service = 'features/my-permissions';

  constructor(private feathersService: FeathersService) {}

  get(): Observable<MyPermission[]> {
    const service = this.feathersService.service(this.service);
    return from(service.find()).pipe(
      map((response: any) => {
        console.log('Service response:', response);
        return response.data || response;
      }),
      catchError(error => {
        console.error('Error in MyPermissionService:', error);
        throw error;
      })
    );
  }
} 